import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef
} from '@angular/material/legacy-dialog';
import { PortalV2Service } from '../../../app/services/portal-v2.service';
import { UserBehaviorService } from '../../services/user-events/user-behavior.service';
import { cloneDeep } from 'lodash';
import { RequesSetupService } from '../../../app/services/request-setup.service';
import {
  MatLegacySnackBar as MatSnackBar,
  MatLegacySnackBarConfig as MatSnackBarConfig
} from '@angular/material/legacy-snack-bar';
import { catchError, takeUntil } from 'rxjs/operators';
import { Subject, throwError } from 'rxjs';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { TableAgGridComponent } from '../../components/table-ag-grid/table-ag-grid.component';
import { NgIf, NgClass, NgFor, DecimalPipe } from '@angular/common';

interface SortState {
  [key: string]: 'asc' | 'desc';
}
let sortState: { [key: string]: 'asc' | 'desc' } = {};
let sortedKeys: string[] = []; // Array de propriedades ordenadas
// const sortState: SortState = {};
@Component({
  selector: 'app-billing-information',
  templateUrl: './billing-information.component.html',
  styleUrls: ['./billing-information.component.css'],
  standalone: true,
  imports: [NgIf, NgClass, NgFor, TableAgGridComponent, MatButtonModule, DecimalPipe]
})
export class BillingInformationComponent implements OnInit, OnDestroy {
  username: string | undefined = '';
  email!: string | undefined;
  activeColumn: string | null = null;
  orderAsc: boolean = true;
  revertSort: any[] = [];
  showSort: boolean = false;
  activeSort: boolean = false;
  soldToClientName: any;
  financial: any;
  auxFinancial: any;
  auxFS: any;

  /*Vars Summarized*/
  billedQty: any;
  billedNetTotalAmt: any;
  collectedNetReceived: any;
  invoiceQtyBacklog: any;
  billedBacklogAmt: any;
  backlogCollectedNetReceived: any;
  credBilledQuantity: any;
  invCredNetValueItemUSD: any;
  debBilledQuantity: any;
  invDebNetValueItemUSD: any;
  nameCombo: string = '';
  selectCombo: string = '';
  onInputSearchBy: any;
  setTimeCSV: boolean = false;

  /**Vars Search By */
  nameComboFilterBy!: string;
  selectComboFilterBy!: string;
  named = '';
  filterInput = '';
  showMore: boolean = false;
  skeletonTable: any;
  repeatSk: any[] = Array(4).fill(null);
  modalName: any;
  orderNumber: any;
  orderItemNumber: any;
  clientName: any;
  soStatus: any;
  tableResp: any;
  downloadCsvPath: any;
  returnList: any[] = [];
  path: any;
  get: any;
  userId: any;
  isLoading: boolean = false;
  params: any;
  checkedUser: boolean = false;

  optionsFilterBy = [
    { id: 'billingDocument', view: 'Billing Document' },
    { id: 'billingType', view: 'Billing Type' },
    { id: 'customerName', view: 'Customer Name' },
    { id: 'netValueUsd', view: 'SO Net Amt' },
    { id: 'soTotalNetValueUsd', view: 'Billing Net Amt' },
    { id: 'billingBacklog', view: 'Billing Backlog' },
    { id: 'receivableNetUsd', view: 'Collected Net Amt' },
    { id: 'invoiceNetOpenRecAmountUsd', view: 'Collected Backlog Amt' },
    { id: 'taxAmountUsd', view: 'Tax Amt' },
    { id: 'grossValueUsd', view: 'Gross Amt' },
    { id: 'receivableUsd', view: 'Collected Gross Amt' },
    { id: 'invoiceOpenRecAmountUsd', view: 'Collected Gross Backlog' },
    { id: 'cmName', view: 'CM Name' },
    { id: 'termsOfPayment', view: 'Termf Of Payment' },
    { id: 'bookToInvoiceDaysGroup', view: 'Book To Invoice Aging' }
  ];
  isPageFlipped: boolean = false;

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private service: PortalV2Service,
    private serviceEnvApi: RequesSetupService,
    private userBehavior: UserBehaviorService,
    public dialogRef: MatDialogRef<any>,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.orderNumber = cloneDeep(this.data.orderNumber);
    this.orderItemNumber = cloneDeep(this.data.orderItemNumber);
    this.modalName = cloneDeep(this.data.modalName);
    this.clientName = cloneDeep(this.data.clientName);
    this.soStatus = cloneDeep(this.data.status);
    this.path = cloneDeep(this.data.path);
    this.get = cloneDeep(this.data.get);
    this.userId = cloneDeep(this.data.userId);
    this.params = cloneDeep(this.data.param);

    if (this.data.env !== undefined && this.data.env === 'API') {
      this.getModalDataApi();
    } else {
      this.getModalData();
    }
  }

  async ngOnInit() {
    const user = await this.userBehavior.fromBehavior();
    if (user) {
      this.email = user?.email;
      this.username = user?.name;
    }
  }

  showMoreLess() {
    this.showMore = !this.showMore;
    if (this.showMore) {
      this.dialogRef.updateSize('100vw', '100%');
    } else {
      this.dialogRef.updateSize('40vw', '100%');
    }
  }

  getDataByPath() {
    this.skeletonTable = true;
    this.service
      .getFinancialStatements(this.orderNumber)
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp) => {
        this.financial = resp;
        this.auxFinancial = resp;
        this.auxFS = resp;
        this.skeletonTable = false;
      });
  }

  getModalDataApi() {
    this.skeletonTable = true;
    this.serviceEnvApi
      .getModalRequest(this.path, this.data.get, this.params)
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp) => {
        this.tableResp = resp;
        this.downloadCsvPath = resp?.downloadCsv ? resp.downloadCsv : '';
        this.skeletonTable = false;
      });
  }

  // modal datas
  getModalData() {
    this.skeletonTable = true;
    this.returnList.push({
      col: 'none',
      value: this.orderNumber?.toString(),
      path: this.path,
      modalName: this.modalName,
      get: this.get,
      param: this.params
    });
    this.service
      .getModalMovements(this.path, this.orderNumber?.toString(), this.data.get, this.params)
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp) => {
        this.tableResp = resp;
        this.downloadCsvPath = resp?.downloadCsv ? resp.downloadCsv : '';
        this.skeletonTable = false;
      });
  }

  getModalDataByParam(path: string, value: any, get: any, returnList?: boolean) {
    if (!returnList) {
      this.returnList.push({
        col: 'none',
        value: this.orderNumber?.toString(),
        path: this.path,
        modalName: this.modalName,
        get: this.get,
        param: this.params
      });
    }
    this.skeletonTable = true;
    this.service
      .getModalMovements(path, value.toString(), get, this.params)
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp) => {
        this.tableResp = resp;
        this.downloadCsvPath = resp?.downloadCsv ? resp.downloadCsv : '';
        this.skeletonTable = false;
      });
  }

  //Select table
  selectedCombo(named: string) {
    switch (named) {
    }
  }

  // select filter by
  selectedComboInput() {
    this.financial = this.auxFinancial.filter((obj: any) => {
      return (
        obj.hasOwnProperty(this.named) &&
        obj[this.named].toString().toLowerCase().includes(this.filterInput.toString().toLowerCase())
      );
    });
    this.auxFS = this.financial;
    if (this.financial.length === 0 && this.filterInput.length > 0) {
      this.financial = [];
    } else if (this.financial.length === 0 && this.filterInput.length === 0) {
      this.financial = this.auxFinancial;
      this.auxFS = this.auxFinancial;
      this.financial = this.auxFinancial;
    }
  }

  //Sort By Table Main
  sortByProperty(property: string) {
    if (this.activeColumn === property) {
      sortState[property] = sortState[property] === 'asc' ? 'desc' : 'asc';
    } else {
      this.activeColumn = property;
      sortState = { [property]: 'desc' };
      sortedKeys = [property];
    }

    this.financial.sort((a: any, b: any) => {
      for (const key of sortedKeys) {
        const order = sortState[key] === 'asc' ? 1 : -1;
        if (a[key] < b[key]) return -1 * order;
        if (a[key] > b[key]) return 1 * order;
      }
      return 0;
    });
  }

  /* Close Modal */
  closeDialog() {
    this.dialogRef.close();
  }

  checkUser(data: {
    checkbox?: any;
    emailAddress?: any;
    userId?: any;
    userName?: any;
    userShortName?: any;
    saveData?: any;
  }) {
    this.isLoading = true;
    data.saveData.body['createdBy'] = this.userId;
    data.saveData.body['updatedBy'] = this.userId;
    data.saveData.body['statusFlag'] = data.checkbox == true ? '1' : '0';
    this.serviceEnvApi
      .saveCheckUser(data.saveData.path, data.saveData.body)
      .pipe(
        catchError((error: any) => {
          const errorMessage = `Erro: ${error.message || 'Erro'}`;
          this.snackBar(errorMessage, 'Erro', 'error');
          this.isLoading = false;
          this.data.changed = true;
          return throwError(errorMessage);
        })
      )
      .subscribe((resp) => {
        this.isLoading = false;
        this.data.changed = true;
        this.snackBar(
          `Action successfully completed for ${data.userName == undefined ? this.clientName : data.userName}!`,
          'OK',
          'success'
        );
      });
  }

  snackBar(message: string, action: string, type: 'success' | 'error') {
    const config = new MatSnackBarConfig();
    config.horizontalPosition = 'end';
    config.verticalPosition = 'top';
    config.duration = 3000;
    config.panelClass = [type === 'success' ? 'success-snackbar' : 'error-snackbar'];
    this._snackBar.open(message, action, config);
  }

  onCustomCellClick(event: any) {
    if (event.column == 'checkbox') {
      this.checkUser(event.data);
    } else if (event.cellClass === 'flow') {
      const text = event.value;
      const regexText = /- (.*?) :/;
      const regexNumber = /: (.*?) -/;
      const matchText = regexText.exec(text);
      const matchNumber = regexNumber.exec(text);
      if (matchText && matchText.length >= 2 && matchNumber && matchNumber.length >= 2) {
        const extractedText = matchText[1].trim();
        const extractedNumber = matchNumber[1].trim();
        this.flowDoc(extractedText, extractedNumber);
      } else {
      }
    } else {
      this.modalName = event.modalName;
      this.orderNumber = event.value;
      this.getModalDataByParam(event.path, event.value, event.get);
    }
  }

  flowDoc(text: any, number: any) {
    const paramsBilling = {
      salesDocumentNumber: null,
      billingBlock: null,
      itemShipToClientName: null,
      itemShipToClientLocation: null,
      serviceProductClass: null,
      itemBookingReqDelivDate: null,
      soItemStatus: null,
      area: null,
      channel: null,
      shipmentType: null,
      itemCategory: null,
      itemCategoryDesc: null,
      completeDeliveryRequired: null,
      poRequiredFlag: null,
      salesOrderDate: null,
      billingDocument: number,
      materialDocumentNumber: null,
      delivery: false
    };

    const paramsInventory = {
      salesDocumentNumber: null,
      billingBlock: null,
      itemShipToClientName: null,
      itemShipToClientLocation: null,
      serviceProductClass: null,
      itemBookingReqDelivDate: null,
      soItemStatus: null,
      area: null,
      channel: null,
      shipmentType: null,
      itemCategory: null,
      itemCategoryDesc: null,
      completeDeliveryRequired: null,
      poRequiredFlag: null,
      salesOrderDate: null,
      billingDocument: null,
      materialDocumentNumber: number,
      delivery: false
    };

    const openModal = (apiEndpoint: any, number: any, params: any, modalTitle: any) => {
      this.getAnotherModal(apiEndpoint, number.toString(), false, params, modalTitle);
    };

    switch (text) {
      case 'Order':
        const orderUrl = './s2p/portal-view-details/' + number;
        window.open(orderUrl, '_blank');
        break;
      case 'Contract':
        break;
      case 'Cancel Goods Issue':
      case 'Goods receipt':
      case 'Returns':
      case 'Delivery':
      case 'WMS transfer order':
      case 'Goods movement':
      case 'Returns delivery for order':
        openModal(
          '/api/v1/search-to-procure-v2-modals/inventory-movements/',
          number,
          paramsInventory,
          'Inventory Movement'
        );
        break;
      case 'Credit memo request':
      case 'Debit memo request':
      case 'Invoice':
      case 'Invoice canceled':
      case 'Credit memo':
      case 'Debit memo':
      case 'Credit memo canceled':
        openModal(
          '/api/v1/search-to-procure-v2-modals/financial-statements',
          number,
          paramsBilling,
          'BILLING INFORMATIONS'
        );
        break;
      case 'Purchase Order':
        break;
      default:
        break;
    }
  }

  getAnotherModal(path: any, orderNumber: any, get: boolean, param: any, modalName: any) {
    this.returnList.push({
      col: 'none',
      value: orderNumber?.toString(),
      path: path,
      modalName: modalName,
      get: get,
      param: param
    });
    this.modalName = modalName;
    this.orderNumber = orderNumber;
    this.path = path;
    this.skeletonTable = true;
    this.params = param;
    this.service
      .getModalMovements(path, orderNumber?.toString(), get, param)
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp) => {
        this.tableResp = resp;
        this.downloadCsvPath = resp?.downloadCsv ? resp.downloadCsFv : '';
        this.skeletonTable = false;
      });
  }

  returnBtn() {
    if (this.returnList.length >= 2) {
      const penultimateItem = this.returnList[this.returnList.length - 2];
      this.modalName = penultimateItem.modalName;
      this.orderNumber = penultimateItem.value;
      this.path = penultimateItem.path;
      this.params = penultimateItem.param;
      this.getModalDataByParam(penultimateItem.path, penultimateItem.value, penultimateItem.get, true);
      this.returnList.pop();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$?.complete();
  }
}
